import React, { useState, useEffect, useContext } from "react";
import useAxios from "../../services/useAxios";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import useWindowSize from "../../hooks/useWindowSize";
// styles
// import colorSchema from "../../assets/kits/colors";
import "./ShopPage.scss";
import colorSchema from "../../assets/kits/colors/colors.module.scss";

// components
import ShopInfo from "../../components/ShopPage/ShopInfo/ShopInfo";
import { CustomInput } from "../../components/kits/inputs/Input";
import Lines from "../../components/ShopPage/Lines/Lines";
import ProductListDrawer from "../../components/ShopPage/productList/ProductListDrawer/ProductListDrawer";
import Loader from "../../components/kits/Loader";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";
import CartItemBtn from "../../components/cartitem/CartitemBtn";
import CloseDrawer from "../../components/ShopPage/CloseDrawer/CloseDrawer";
import ProductListShop from "../../components/ShopPage/productList/ProductListShop/ProductListShop";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import { toast } from "react-toastify";
import SnackBar from "../../components/kits/SnackBar";
import ColorSchema from "../../assets/kits/colors";
import { ArrowLeftIcon } from "../../components/kits/Icons/Icons";
import { getBoxByPosition } from "../../utilities/apiTools";
import BoxSlider from "../../components/common/slider/BoxSlider";
export default function ShopPage() {
  const { shopId } = useParams();
  const [isOpenShoppingCart, setIsOpenShoppingCart] = useState(false);
  const [isOpenDrawerClose, setIsOpenDrawerClose] = useState(false);
  const [productList, setProductList] = useState([
    {
      title: "تو هر خونه ای لازمه",
      items: [
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
      ],
    },
    {
      title: "سفید کننده",
      items: [
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
      ],
    },
    {
      title: "شوینده",
      items: [
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
        { imagePath: "", title: "تست", price: "1000" },
      ],
    },
  ]);
  const [heightNewDrawer, setHeightNewDrawer] = useState(264);
  const [transition, setTransition] = useState("none");
  const [shopIsOpen, setShopISOpen] = useState(false);
  const [shopInfo, setShopInfo] = useState({
    cover_file: [],
    supplier: [],
    logo_file: [],
    supplier_line_links: [],
  });
  const [defaultSize, setDefaultSize] = useState(false);
  const { loading, execute: ShopInfoApi } = useAxios(
    "superadminapi/get_edit_suppliers_data",
    { supplier_id: shopId }
  );
  const ShopInfoFunc = async () => {
    await ShopInfoApi().then((data) => {
      setShopInfo(data);
    });
  };

  const { execute: get_config } = useAxios("api/get_config");
  const { execute: config_filter } = useAxios("api/config_filter");
  const [configsProduct, setConfigsProduct] = useState([]);

  useEffect(() => {
    get_config("").then((data) => {
      let form = new FormData();
      form.append("supplierId", shopId);
      let getProduct = [];
      data.filter_configs.map((item, index) => {
        form.delete("usertoken");
        form.delete("configIndex");
        form.append("configIndex", index);
        config_filter(form).then((products) => {
          getProduct[index] = {
            title: item.title,
            items: products.items,
            index: index,
          };
          if (data.filter_configs.length == getProduct.length) {
            setConfigsProduct(getProduct);
          }
        });
      });
    });
  }, []);

  useEffect(() => {}, [configsProduct.length]);

  const { getItemsShop } = useContext(ShoppingCartItemContext);
  const shoppingCartData = getItemsShop(shopId);
  const showShoppingCartSec = () => {
    if (shoppingCartData.items?.length > 0) setIsOpenShoppingCart(true);
    else setIsOpenShoppingCart(false);
  };
  const situationShopFunc = (
    startHour,
    startMin,
    finishHour,
    finishMin,
    status
  ) => {
    let situation = <></>;
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }
    let currentHour = addZero(new Date().getHours());
    let currentMin = addZero(new Date().getMinutes());

    if (
      (startHour != "" && currentHour < startHour) ||
      (finishHour != "" && currentHour > finishHour) ||
      (startHour != "" && currentHour == startHour && currentMin < startMin) ||
      (finishHour != "" &&
        currentHour == finishHour &&
        currentMin > finishMin) ||
      status != 0 ||
      shopInfo?.supplier_line_links?.length == 0
    ) {
      situation = (
        <div className="mr-l-8 desc-l pd-x-4 pd-t-2 close">
          <span style={{ color: colorSchema.schema_negative_main }}>
            بسته است
          </span>
          <p className="dot close mr-r-4" />
        </div>
      );
      setShopISOpen(false);
    } else if (
      (startHour != "" &&
        currentHour > startHour &&
        finishHour != "" &&
        currentHour < finishHour) ||
      (startHour != "" &&
        currentHour == startHour &&
        currentMin > startMin &&
        finishHour != "" &&
        currentHour < finishHour) ||
      (finishHour != "" &&
        currentHour == finishHour &&
        currentMin < finishMin &&
        startHour != "" &&
        currentHour > startHour) ||
      finishHour == "" ||
      startHour == ""
    ) {
      situation = (
        <div className="mr-l-8 desc-l pd-x-4 pd-t-2 open">
          <span style={{ color: colorSchema.foreground_background_he }}>
            باز است
          </span>
          <p className="dot open mr-r-4" />
        </div>
      );
      setShopISOpen(true);
    }
    return situation;
  };
  const backToDefault = (e) => {
    setDefaultSize(true);
    setHeightNewDrawer(264);
    setTransition("height 1s");
  };
  useEffect(() => {
    ShopInfoFunc();
  }, []);
  useEffect(() => {
    showShoppingCartSec();
  }, [shoppingCartData]);
  const auth = useContext(AuthenticationContext);

  const [boxBanners, setBoxBanners] = useState({});
  useEffect(() => {
    const loadBanner = async () =>
      setBoxBanners(await getBoxByPosition("e11,e12,e13,e14,e15"));
    loadBanner();
  }, []);
  return loading ? (
    <div className="d-flex align-items-center justify-content-center h-100">
      <Loader width={40} />
    </div>
  ) : (
    <div
      className="shop-page"
      style={{
        height: "100%",
        overflow: "auto",
        paddingBottom: isOpenShoppingCart ? "72px" : 0,
      }}
      onScroll={backToDefault}
    >
      {boxBanners.e11 && (
        <div className="mr-b-20 pd-x-20">
          <BoxSlider banner={boxBanners.e11} />
        </div>
      )}

      <ShopInfo
        ShopInfoData={shopInfo}
        situationShopFunc={situationShopFunc}
        banner={boxBanners.e12}
      />

      {shopInfo.supplier_line_links.length == 0 && (
        <SnackBar
          className="txt-t2-r text-decoration-none mr-20 pd-x-16 pd-y-14"
          style={{ height: 48 }}
          text={`این فروشگاه تا اطلاع ثانوی غیرفعال است.`}
          color={ColorSchema.foreground_surface_me}
          backgroundColor={ColorSchema.schema_surface_light}
          borderColor={ColorSchema.foreground_outline_darker}
          button
        />
      )}

      {boxBanners.e13 && (
        <div className="mr-b-12 pd-x-20">
          <BoxSlider banner={boxBanners.e13} />
        </div>
      )}
      <NavLink to={`/store-search/${shopId}`} className="text-decoration-none">
        <div className="mr-20">
          <CustomInput
            placeholder={`جستجو در ${shopInfo?.supplier[0]?.title}`}
            haveIcon={true}
            className="input-shop"
          />
        </div>
      </NavLink>

      {boxBanners.e14 && (
        <div className="mr-b-20 pd-x-20">
          <BoxSlider banner={boxBanners.e14} />
        </div>
      )}

      <Lines linesList={shopInfo.supplier_line_links} shopId={shopId} />

      {boxBanners.e15 && (
        <div className="mr-t-12 pd-x-20">
          <BoxSlider banner={boxBanners.e15} />
        </div>
      )}

      {/* <OverlayScrollbarsComponent
        style={{ height: isOpenShoppingCart ? 190 : 270 }}
      >
        <ProductListDrawer
          heightNewDrawer={heightNewDrawer}
          setHeightNewDrawer={setHeightNewDrawer}
          isOpenShoppingCart={isOpenShoppingCart}
          defaultSize={defaultSize}
          setDefaultSize={setDefaultSize}
          transition={transition}
          setTransition={setTransition}
          component={
            <ProductListShop
              itemsList={productList}
              shopIsOpen={shopIsOpen}
              setIsOpenDrawerClose={setIsOpenDrawerClose}
            />
          }
        />
      </OverlayScrollbarsComponent> */}
      <div>
        <CloseDrawer
          isOpen={isOpenDrawerClose}
          setIsOpen={setIsOpenDrawerClose}
          shopName={shopInfo?.supplier[0]?.title}
        />
      </div>
      <div>
        {configsProduct.length == 0 ? (
          ""
        ) : (
          <ProductListShop
            itemsList={configsProduct}
            shopId={shopId}
            shopIsOpen={shopIsOpen}
          />
        )}
      </div>
      {shoppingCartData.items?.length > 0 && (
        <CartItemBtn
          isOpen2={shoppingCartData.items?.length > 0}
          shopId={shopId}
        />
      )}
    </div>
  );
}
